import HttpService from "../utils/api";
const BASE_URL = "/users/Security";

function getUserRole(): Promise<any> {
  return HttpService.req(`${BASE_URL}/Roles/Mine`);
}

function getUserRoles(email: string): Promise<any> {
  return HttpService.req(`${BASE_URL}/Roles/Users/${email}`);
}

export const SecurityService = {
  getUserRole,
  getUserRoles
};
